export interface cardImageMapperIf {
  // back
  back: string;
  // Heart
  "♥A": string;
  "♥2": string;
  "♥3": string;
  "♥4": string;
  "♥5": string;
  "♥6": string;
  "♥7": string;
  "♥8": string;
  "♥9": string;
  "♥10": string;
  "♥J": string;
  "♥Q": string;
  "♥K": string;

  // Spade
  "♠A": string;
  "♠2": string;
  "♠3": string;
  "♠4": string;
  "♠5": string;
  "♠6": string;
  "♠7": string;
  "♠8": string;
  "♠9": string;
  "♠10": string;
  "♠J": string;
  "♠Q": string;
  "♠K": string;

  // Club
  "♣A": string;
  "♣2": string;
  "♣3": string;
  "♣4": string;
  "♣5": string;
  "♣6": string;
  "♣7": string;
  "♣8": string;
  "♣9": string;
  "♣10": string;
  "♣J": string;
  "♣Q": string;
  "♣K": string;
  // Diamond
  "♦A": string;
  "♦2": string;
  "♦3": string;
  "♦4": string;
  "♦5": string;
  "♦6": string;
  "♦7": string;
  "♦8": string;
  "♦9": string;
  "♦10": string;
  "♦J": string;
  "♦Q": string;
  "♦K": string;
  joker: string;
}

export const cardImageMapper: cardImageMapperIf = {
  // back
  back: "/assets/img/card_back.png",
  // Heart
  "♥A": "/assets/img/card_heart_01.png",
  "♥2": "/assets/img/card_heart_02.png",
  "♥3": "/assets/img/card_heart_03.png",
  "♥4": "/assets/img/card_heart_04.png",
  "♥5": "/assets/img/card_heart_05.png",
  "♥6": "/assets/img/card_heart_06.png",
  "♥7": "/assets/img/card_heart_07.png",
  "♥8": "/assets/img/card_heart_08.png",
  "♥9": "/assets/img/card_heart_09.png",
  "♥10": "/assets/img/card_heart_10.png",
  "♥J": "/assets/img/card_heart_11.png",
  "♥Q": "/assets/img/card_heart_12.png",
  "♥K": "/assets/img/card_heart_13.png",

  // Spade
  "♠A": "/assets/img/card_spade_01.png",
  "♠2": "/assets/img/card_spade_02.png",
  "♠3": "/assets/img/card_spade_03.png",
  "♠4": "/assets/img/card_spade_04.png",
  "♠5": "/assets/img/card_spade_05.png",
  "♠6": "/assets/img/card_spade_06.png",
  "♠7": "/assets/img/card_spade_07.png",
  "♠8": "/assets/img/card_spade_08.png",
  "♠9": "/assets/img/card_spade_09.png",
  "♠10": "/assets/img/card_spade_10.png",
  "♠J": "/assets/img/card_spade_11.png",
  "♠Q": "/assets/img/card_spade_12.png",
  "♠K": "/assets/img/card_spade_13.png",

  // Club
  "♣A": "/assets/img/card_club_01.png",
  "♣2": "/assets/img/card_club_02.png",
  "♣3": "/assets/img/card_club_03.png",
  "♣4": "/assets/img/card_club_04.png",
  "♣5": "/assets/img/card_club_05.png",
  "♣6": "/assets/img/card_club_06.png",
  "♣7": "/assets/img/card_club_07.png",
  "♣8": "/assets/img/card_club_08.png",
  "♣9": "/assets/img/card_club_09.png",
  "♣10": "/assets/img/card_club_10.png",
  "♣J": "/assets/img/card_club_11.png",
  "♣Q": "/assets/img/card_club_12.png",
  "♣K": "/assets/img/card_club_13.png",
  // Diamond
  "♦A": "/assets/img/card_diamond_01.png",
  "♦2": "/assets/img/card_diamond_02.png",
  "♦3": "/assets/img/card_diamond_03.png",
  "♦4": "/assets/img/card_diamond_04.png",
  "♦5": "/assets/img/card_diamond_05.png",
  "♦6": "/assets/img/card_diamond_06.png",
  "♦7": "/assets/img/card_diamond_07.png",
  "♦8": "/assets/img/card_diamond_08.png",
  "♦9": "/assets/img/card_diamond_09.png",
  "♦10": "/assets/img/card_diamond_10.png",
  "♦J": "/assets/img/card_diamond_11.png",
  "♦Q": "/assets/img/card_diamond_12.png",
  "♦K": "/assets/img/card_diamond_13.png",
  // joker
  joker: "/assets/img/card_joker.png",
};
